/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMp3 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m21.808 12.764-1.19 1.215c.24.024.45.081.63.171.248.12.438.29.567.511.133.216.2.47.2.759 0 .345-.08.644-.236.897a1.512 1.512 0 0 1-.675.573c-.29.133-.635.2-1.036.2-.262 0-.515-.028-.758-.083a2.395 2.395 0 0 1-.649-.228v-.918c.189.102.407.182.655.242a3.3 3.3 0 0 0 .711.083c.216 0 .4-.03.552-.09a.722.722 0 0 0 .345-.262.731.731 0 0 0 .117-.42c0-.235-.069-.417-.207-.546-.133-.129-.33-.193-.593-.193-.129 0-.249.011-.36.034-.11.018-.224.05-.344.097l-.338-.566 1.244-1.311h-1.692v-.876h3.057zM10.75 15.288l1.571-3.305h1.125V17h-1.062v-3.249l-1.325 2.766h-.662l-1.325-2.721V17H8.03v-5.017h1.124zm5.469-3.305c.616 0 1.08.143 1.393.428.318.285.477.709.477 1.27 0 .372-.072.685-.214.938a1.328 1.328 0 0 1-.628.566c-.276.13-.619.194-1.028.194h-.725V17h-1.07v-5.017zm-.725 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.235-.635-.152-.124-.411-.186-.779-.186h-.504z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMp3 as FileMp3 };
